<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Assegnazione cliccatori in massa</span>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-4">
				<v-col>
					<v-form ref="assegnazioneCliccatoriInMassaForm">
						<v-radio-group
							v-model="opzioneDiAssegnazioneSelezionata"
							label="Opzioni di invio"
							:rules="[mixin_rules.radioRequired]"
						>
							<v-radio
								v-for="opzione in opzioniDiAssegnazione"
								:key="opzione.key"
								:label="opzione.label"
								:value="opzione.key"
							></v-radio>
						</v-radio-group>

						<v-select
							v-if="mostraTipologiePunteggi"
							v-model="tipologiaPunteggiSelezionata"
							label="Tipologia Calcolo Punteggi"
							:items="tipologiePunteggi"
							outlined
							dense
							:rules="[mixin_rules.selectRequired]"
						></v-select>
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="$emit('close')"
				:disabled="running"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				v-if="mostraAnteprimaAssegnazione"
				color="secondary"
				@click="run(true)"
				:loading="running"
			>
				Mostra anteprima assegnazione
			</v-btn>
			<v-btn
				v-else
				color="secondary"
				@click="dialogConfermaDisassegnazione = true"
				:loading="running"
			>
				OK
			</v-btn>
		</v-card-actions>

		<v-dialog
			v-model="dialogConfermaDisassegnazione"
			max-width="600"
			persistent
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">Conferma operazione</span>
				</v-card-title>
				<v-card-text class="mt-4">
					Sei sicuro di voler proseguire con la scelta dell'opzione:<br>
          <strong>{{ opzioniDiAssegnazione.find(o => o.key === opzioneDiAssegnazioneSelezionata)?.label }}</strong>?<br>
          Non verrà mostrata un'anteprima, verrà eseguita direttamente l'opzione scelta e questa operazione non potrà essere annullata.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						:disabled="running"
						@click="dialogConfermaDisassegnazione = false"
					>
						Annulla
					</v-btn>
					<v-btn
						color="secondary"
						:loading="running"
						@click="dialogConfermaDisassegnazione = false; run()"
					>
						Conferma
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogAnteprimaAssegnazione"
			scrollable
			persistent
			width="unset"
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">
						Anteprima assegnazione: {{ tipologiePunteggi.find(t => t.value == tipologiaPunteggiSelezionata)?.text }}
					</span>
				</v-card-title>
				<v-card-text>
					<v-data-table
						:headers="headers"
						:items="anteprimaAssegnazione"
						:search="search"
						:footer-props="{ 'items-per-page-options': [25, 50, 100] }"
						:items-per-page="25"
						:height="'calc(100vh - 280px)'"
						fixed-header
						multi-sort
						class="mt-3"
					>
						<template v-slot:item.tempo_massimo_ammesso="{ item }">
							{{ item.tempo_massimo_ammesso?.replace('.', ',') }}
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						:disabled="running"
						@click="dialogAnteprimaAssegnazione = false"
					>
						Annulla
					</v-btn>
					<v-btn
						color="secondary"
						:disabled="running"
						:loading="running"
						@click="run()"
					>
						Conferma assegnazione
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
export default {
	props: ['praticheIds'],

	data() {
		return {
			opzioniDiAssegnazione: [
				{
					key: 'assegna_tutti_i_cliccatori_alle_pratiche_in_tabella',
					label: 'Disassegna i cliccatori da tutte le pratiche e assegna tutti i cliccatori alle pratiche in tabella',
				},
				{
					key: 'assegna_i_cliccatori_non_assegnati_alle_pratiche_in_tabella_senza_cliccatore',
					label: 'Assegna i cliccatori non assegnati, alle pratiche in tabella che non hanno un cliccatore assegnato'
				},
				{
					key: 'disassegna_i_cliccatori_da_tutte_le_pratiche',
					label: 'Disassegna i cliccatori da tutte le pratiche'
				},
				{
					key: 'disassegna_i_cliccatori_dalle_pratiche_in_tabella',
					label: 'Disassegna i cliccatori assegnati alle pratiche presenti in tabella'
				}
			],
			opzioneDiAssegnazioneSelezionata: null,
			running: false,

			tipologiePunteggi: [
				{
					text: "Punteggi basati sull'esito",
					value: 'a_successo'
				},

				{
					text: 'Punteggi basati sul tempo',
					value: 'a_tempo'
				}
			],
			tipologiaPunteggiSelezionata: null,

			anteprimaAssegnazione: [],
			dialogAnteprimaAssegnazione: false,
			dialogConfermaDisassegnazione: false,
			headers: [
				{ text: 'ID Pratica', value: 'custom_id' },
				{ text: 'Ragione Sociale Pratica', value: 'ragione_sociale' },
				{ text: 'Regione', value: 'regione' },
				{ text: 'Asse di Finanziamento', value: 'asse_di_finanziamento.nome' },
				{ text: 'Tempo Massimo Ammesso', value: 'dati_per_anteprima_assegnazione.tempo_massimo_ammesso' },
				{ text: 'Importo Agevolazione', value: 'agevolazione_richiesta' },
				{ text: 'Codice Cliccatore', value: 'dati_per_anteprima_assegnazione.codice_cliccatore' },
				{ text: 'Nome Cliccatore', value: 'dati_per_anteprima_assegnazione.nome_cliccatore' },
				{ text: 'Cognome Cliccatore', value: 'dati_per_anteprima_assegnazione.cognome_cliccatore' },
				{ text: 'Posizione in Classifica', value: 'dati_per_anteprima_assegnazione.posizione_classifica' },
				{ text: 'Punti in Classifica', value: 'dati_per_anteprima_assegnazione.punti' },
			],
			search: null
		}
	},

	computed: {
		mostraTipologiePunteggi() {
			return this.opzioneDiAssegnazioneSelezionata == 'assegna_tutti_i_cliccatori_alle_pratiche_in_tabella'
				|| this.opzioneDiAssegnazioneSelezionata == 'assegna_i_cliccatori_non_assegnati_alle_pratiche_in_tabella_senza_cliccatore'
		},
		mostraAnteprimaAssegnazione() {
			return this.opzioneDiAssegnazioneSelezionata == 'assegna_tutti_i_cliccatori_alle_pratiche_in_tabella'
				|| this.opzioneDiAssegnazioneSelezionata == 'assegna_i_cliccatori_non_assegnati_alle_pratiche_in_tabella_senza_cliccatore'
		}
	},

	methods: {
		run(mostraAnteprimaAssegnazione = false) {
			if (!this.$refs.assegnazioneCliccatoriInMassaForm.validate()) return;
			this.running = true;

			axios.post('/api/pratiche/gestione-assegnazione-cliccatori-in-massa', {
				pratiche_ids: this.praticheIds,
				opzione_di_assegnazione: this.opzioneDiAssegnazioneSelezionata,
				mostra_anteprima_assegnazione: mostraAnteprimaAssegnazione,
				tipologia_punteggi: this.tipologiaPunteggiSelezionata
			})
				.then(response => {
					if (mostraAnteprimaAssegnazione) {
						this.anteprimaAssegnazione = response.data;
						this.dialogAnteprimaAssegnazione = true;
					}
					else {
						this.$emit('close');
						this.$emit('done');
					}
				})
				.finally(() => {
					this.running = false;
				})
		}
	}
}
</script>
